import VueNotifications from 'vue-notifications'

export default {
	showSuccess: {
      type: VueNotifications.types.success
    },
    showInfo: {
      type: VueNotifications.types.info
    },
    showWarn: {
      type: VueNotifications.types.warn
    },
    showError: {
      type: VueNotifications.types.error
    }
}